export default "__VITE_ASSET__BAVw7oij__"